import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import {
  DayOption,
  getDaysFromValue,
  getNightsFromValue,
} from '../../../../data/models/funnelOrder/days'
import {
  destinationEnum,
  getDestination,
} from '../../../../data/models/funnelOrder/destination'
import { AppState } from '../../../../data/state'

import { BlockItem, BlockSelect, BlockSelectType } from 'components/BlockSelect'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'
import Style from 'components/Style'
import { SRPRS } from 'Icon/srprs'

import {
  ActionModalInnerComponentProps,
  withActionListModal,
} from '../../../../elements/modals/ActionListModal'
import {
  WarningDispatchProps,
  WarningModal,
  WarningOwnProps,
  WarningStateProps,
} from '../../../../elements/modals/WarningModal'
import { optionSelection } from '../../../../tracking/actions/optionSelection'
import Content from '../../../shared/content'

interface DaysModalProps {
  options: DayOption[]
  hideTrigger?: boolean
  dropdown?: boolean
  children?: React.ReactNode | undefined
}

interface DaysModalState {
  value: number
  viewWarning?: boolean
  newDest: destinationEnum
}

class DaysModal extends React.Component<
  ActionModalInnerComponentProps & DaysModalProps,
  DaysModalState
> {
  constructor(props: ActionModalInnerComponentProps & DaysModalProps) {
    super(props)
    this.state = {
      value: props.value.days || 3,
      newDest: destinationEnum.allOfEurope,
    }
    this.handleSave = this.handleSave.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  public openWarning(dest: destinationEnum) {
    this.setState({
      viewWarning: true,
      newDest: dest,
    })
  }

  public handleSave() {
    if (
      this.props.value.dest !== destinationEnum.outsideEurope &&
      this.state.value === 7
    ) {
      this.openWarning(destinationEnum.outsideEurope)
    } else if (
      this.props.value.dest === destinationEnum.outsideEurope &&
      this.state.value !== 7
    ) {
      this.openWarning(destinationEnum.allOfEurope)
    } else if (this.props.onSave !== undefined) {
      this.props.onSave(this.state.value)
    }
  }

  public handleClose() {
    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  public handleChange(value: string, checked: boolean) {
    this.setState({
      value: +value,
    })
  }

  public render() {
    const optionItems = this.props.options.map(day => (
      <BlockItem
        value={day.days}
        key={day.days}
        labelSubline={
          <>
            <Content contentKey="city-break">City break</Content>
            {day.worldwide === true ? (
              <>
                <br />
                <Content contentKey="only-available-outside-europe">
                  Only available outside Europe
                </Content>
              </>
            ) : null}
          </>
        }
        label={
          <Content
            addNode
            contentKey="vars-days"
            vars={{ days: day.days.toString() }}
          >
            {`${day.days} Days`}
          </Content>
        }
      />
    ))

    return !this.state.viewWarning ? (
      <Modal
        size="xl"
        animationType={'1'}
        sticky={true}
        onDismiss={this.handleSave}
      >
        <ModalHeader icon={SRPRS.calendarColored()}>
          <Content contentKey="num-days">Number of days</Content>
        </ModalHeader>
        <div className="content">
          <Style margin={[[10, 0, 20, 0]]}>
            <BlockSelect
              model="days"
              value={this.state.value}
              onChange={this.handleChange}
              nrCols={[1, 3]}
              type={BlockSelectType.small}
            >
              {optionItems}
            </BlockSelect>
          </Style>
          {this.props.children}
        </div>
        <ModalFooter onClose={this.handleClose} onSave={this.handleSave} />
      </Modal>
    ) : (
      <DaysWarning
        newPrimary={this.state.value}
        newSecondary={this.state.newDest}
        formatSecondary={getDestination}
        icon={SRPRS.mapMarkerColored}
        iconProps={{
          width: '37',
          height: '37',
          viewBox: '0 0 37 41',
          fill: 'none',
        }}
        onClose={this.handleClose}
      />
    )
  }
}

const DaysWarning = connect<
  WarningStateProps,
  WarningDispatchProps,
  WarningOwnProps,
  AppState
>(
  state => ({ oldSecondary: state.funnelOrder.destination }),
  dispatch => ({
    onChangePrimary: (days: number) => {
      optionSelection('days', days)
      dispatch(actions.change('funnelOrder.days', days))
    },
    onChangeSecondary: (dest: destinationEnum) => {
      dispatch(actions.change('funnelOrder.destination', dest))
    },
  }),
)(WarningModal)

const Days = connect(
  (state: AppState) => ({
    value: {
      dest: state.funnelOrder.destination,
      days: state.funnelOrder.days,
    },
  }),
  dispatch => ({
    onChange: (days: number) => {
      optionSelection('days', days)
      dispatch(actions.change('funnelOrder.days', days))
    },
  }),
  (stateProps, dispatchProps, ownProps: DaysModalProps) => ({
    value: Object.assign(stateProps.value, { options: ownProps.options }),
    ...ownProps,
    onChange: (days: number) => {
      if (stateProps.value.days !== days) {
        dispatchProps.onChange(days)
      }
    },
  }),
)(
  withActionListModal<DaysModalProps>(DaysModal, {
    icon: SRPRS.calendarColored(),
    subject: (
      <Content addNode contentKey="num-days">
        Number of days
      </Content>
    ),
    getValue: getDaysFromValue,
    getSubValue: getNightsFromValue,
  }),
)

export default Days
